import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import Done from './Done';
import Gender from './Gender';
import Hero from './Hero';
import Plans from './Plans';
import PlanTypes from './PlanTypes';

enum Steps {
  hero = 'hero',
  name = 'name',
  phoneNumber = 'phone-number',
  birthday = 'birthday',
  gender = 'gender',
  planTypes = 'plan-types',
  plans = 'plans',
  done = 'done',
}

const steps = [Steps.hero, Steps.gender, Steps.planTypes, Steps.plans, Steps.done];

export interface WizardState {
  zipCode?: string;
  gender?: string;
  planN?: any[];
  planG?: any[];
}

const Wizard = () => {
  const router = useRouter();

  const [wizardState, setWizardState] = useState<WizardState | null>({});

  const step = router.query && router.query.step ? (router.query.step as string) : steps[0];
  const stepIndex = steps.indexOf(step as Steps);

  useEffect(() => {
    if (step === Steps.gender && !wizardState.zipCode) {
      router.replace(router.pathname);
    } else if (step === Steps.planTypes && !wizardState.gender) {
      router.replace(router.pathname);
    } else if (step === Steps.plans && !wizardState.planN && !wizardState.planG) {
      router.replace(router.pathname);
    }
  }, []);

  const goNext = (values = null) => {
    if (values) {
      setWizardState((prev) => {
        return {
          ...prev,
          ...values,
        };
      });
    }
    router.push(`${router.pathname}?step=${steps[stepIndex + 1]}`);
  };

  const renderStage = useCallback(() => {
    switch (step) {
      case steps[0]:
        return <Hero goNext={goNext} />;
      case steps[1]:
        return <Gender goNext={goNext} />;
      case steps[2]:
        return <PlanTypes wizardState={wizardState} goNext={goNext} />;
      case steps[3]:
        return <Plans wizardState={wizardState} />;
      case steps[4]:
        return <Done />;
      default:
        return null;
    }
  }, [step]);

  return renderStage();
};

export default Wizard;
